/**
 * Interest Popup for Amazon Marketing Theme
 * 
 * Creates a simple, text-only interactive popup that asks customers about their interests
 * and directs them to relevant service pages.
 * Only shows on the home page, once per session.
 */

(function() {
  // Initialize popup functionality when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initInterestPopup();
  });

  /**
   * Initialize interest popup functionality
   */
  function initInterestPopup() {
    const popup = document.querySelector('.interest-popup');
    
    if (!popup) return;
    
    // Only show on the home page
    const isHomePage = window.location.pathname === '/' || 
                       window.location.pathname === '/index' || 
                       window.location.pathname === '/index.html' ||
                       window.location.pathname.includes('/collections/frontpage');
    
    if (!isHomePage) return;
    
    // Check if the popup has been shown in this session
    const hasSeenPopupThisSession = sessionStorage.getItem('hasSeenInterestPopup');
    
    // Only show the popup if it hasn't been shown in this session
    if (hasSeenPopupThisSession) return;
    
    // Show the popup with a slight delay for better user experience
    setTimeout(function() {
      popup.classList.add('active');
      document.body.classList.add('popup-open');
      
      // Mark as seen for this session
      sessionStorage.setItem('hasSeenInterestPopup', 'true');
    }, 1500);
    
    // Close popup when clicking the close button
    const closeButton = popup.querySelector('.interest-popup__close');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        closePopup();
      });
    }
    
    // Close popup when clicking outside
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        closePopup();
      }
    });
    
    // Handle service button clicks
    const serviceButtons = popup.querySelectorAll('.interest-popup__button');
    serviceButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const serviceUrl = this.getAttribute('data-url');
        console.log('Service clicked, URL:', serviceUrl);
        if (serviceUrl) {
          window.location.href = serviceUrl;
        } else {
          closePopup();
        }
      });
    });
    
    // Handle skip button click
    const skipButton = document.getElementById('interest-popup-skip');
    if (skipButton) {
      skipButton.addEventListener('click', function() {
        console.log('Skip button clicked');
        closePopup();
      });
    }
    
    // Function to close the popup
    function closePopup() {
      console.log('Closing popup');
      popup.classList.remove('active');
      document.body.classList.remove('popup-open');
    }
  }
  
  /**
   * Dynamically fetch services from the website and update the popup
   * This can be used if you want to automatically populate the services from your collections
   */
  function fetchServicesFromWebsite() {
    // This is a placeholder function that would normally fetch data from your Shopify store
    // For example, you could use the Shopify AJAX API to get collections
    // For now, we'll use the hardcoded services in the HTML
    
    // Example of how this might work with a real API call:
    /*
    fetch('/collections.json')
      .then(response => response.json())
      .then(data => {
        const servicesContainer = document.querySelector('.interest-popup__services');
        servicesContainer.innerHTML = ''; // Clear existing buttons
        
        // Add a button for each collection
        data.collections.forEach(collection => {
          const button = document.createElement('button');
          button.className = 'interest-popup__button';
          button.setAttribute('data-url', '/collections/' + collection.handle);
          button.textContent = collection.title;
          
          button.addEventListener('click', function() {
            window.location.href = this.getAttribute('data-url');
          });
          
          servicesContainer.appendChild(button);
        });
      })
      .catch(error => {
        console.error('Error fetching collections:', error);
      });
    */
  }
  
  /**
   * Reset popup for testing purposes
   * Call this function from console to test the popup again:
   * resetInterestPopup();
   */
  window.resetInterestPopup = function() {
    localStorage.removeItem('hasSeenInterestPopup');
    console.log('Interest popup reset. Refresh the page to see it again.');
    
    // Reload the page to show the popup again
    window.location.reload();
  };
})();
